/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';

import { NgbDateParserFormatter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateITParserFormatter } from './@core/utils/ngb-date-it-parser-formatter';
import { NgbDateNativeAdapter } from './@core/utils/ngb-date-native-adapter';
import { NbIconLibraries } from '@nebular/theme';
import { NbToastrService } from '@nebular/theme';

@Component({
    selector: 'ngx-app',
    template: `
    <router-outlet></router-outlet>
  `,
    providers: [
        { provide: NgbDateParserFormatter, useClass: NgbDateITParserFormatter },
        { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    ],
})
export class AppComponent implements OnInit {

    constructor(
        private iconLibraries: NbIconLibraries,
        public toastrService: NbToastrService /*, private analytics: AnalyticsService*/) {
        this.iconLibraries.registerFontPack('fa', { packClass: 'fa' });
        this.iconLibraries.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
        this.iconLibraries.registerFontPack('mdi', { packClass: 'mdi' });
        this.iconLibraries.registerFontPack('ion', { iconClassPrefix: 'ion' });
    }

    ngOnInit(): void {
        /*this.analytics.trackPageViews();*/
    }
}
